import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateDeleteChatList = {
  deleteChatList: { data: null, loading: false, error: null },
};

export const deleteChatList = createAsyncThunk('user/deleteChatList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/chat/chats/deletion`, data, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response);
    });
});

export const reducerDeleteChatList = {
  [deleteChatList.pending]: (state) => {
    // state.deleteChatList.data = null;
    state.deleteChatList.loading = true;
    state.deleteChatList.error = null;
  },
  [deleteChatList.fulfilled]: (state, action) => {
    state.deleteChatList.loading = false;
    state.deleteChatList.data = true;
    state.deleteChatList.error = null;
  },
  [deleteChatList.rejected]: (state, action) => {
    state.deleteChatList.loading = false;
    state.deleteChatList.error = action;
  },
};
